import { ProviderField } from './providerTemplates';

export interface ValidationError {
  [fieldKey: string]: string;
}

export const validateProviderConfig = (
  fields: ProviderField[],
  config: Record<string, string>
): ValidationError => {
  const errors: ValidationError = {};

  fields.forEach(field => {
    const value = config[field.key] || '';

    // Required field validation
    if (field.required && !value.trim()) {
      errors[field.key] = `${field.label} is required`;
      return;
    }

    // Skip validation for empty optional fields
    if (!field.required && !value.trim()) {
      return;
    }

    // Type-specific validation
    switch (field.type) {
      case 'email':
        if (value && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
          errors[field.key] = 'Please enter a valid email address';
        }
        break;

      case 'textarea':
        if (field.key === 'service_account_key' && value) {
          try {
            JSON.parse(value);
          } catch {
            errors[field.key] = 'Please enter valid JSON';
          }
        }
        break;

      case 'text':
        // Special validation for specific fields
        if (field.key === 'zone_id' && value && !/^[a-f0-9]{32}$/.test(value)) {
          errors[field.key] = 'Zone ID should be a 32-character hexadecimal string';
        }
        break;
    }

    // Length validation
    if (value && value.length < 3) {
      errors[field.key] = `${field.label} must be at least 3 characters`;
    }
  });

  return errors;
};

export const hasValidationErrors = (errors: ValidationError): boolean => {
  return Object.keys(errors).length > 0;
};

export const getFirstError = (errors: ValidationError): string | undefined => {
  const firstKey = Object.keys(errors)[0];
  return firstKey ? errors[firstKey] : undefined;
};